export const CATEGORIES_LABEL = "categories";
export const CLOTHING_LABEL = "clothing";
export const DISCOVER_MORE_LABEL = "discover more";
export const MARKETPLACE_LABEL = "marketplace";
export const MARKETPLACE_ID = "marketplaceLink";
export const SHOP_BY_PRODUCT_LABEL = "shop by product";
export const CTAS_LABEL = "ctas";
